import { 
  getApiCategories,
  getGuideCategories,
  getFAQCategories,
  getApiArticles,
  getGuideArticles,
  getFAQArticles,
  getApiArticlesNew,
  getApiArticleDetail,
  getGuideArticleDetail,
  getQuestionContentList,
  getFAQCategoriesNew,
  readContentAdd
} from 'api';

function getQuery(key){
  var reg = new RegExp("(^|&)"+key+"=([^&]*)(&|$)");
  var result = window.location.search.substr(1).match(reg);
  return result?decodeURIComponent(result[2]):null;
}

export function useDocType(defaultDocType) {
  const type = getQuery('docType') || defaultDocType;
  return [type];
}

export function ceiling(obj) {
  console.log(obj.current)
  var ot = obj.current.offsetTop;
  console.log(ot)
  window.onscroll = function () {
      var st = document.body.scrollTop || document.documentElement.scrollTop;
      obj.current.setAttribute("data-fixed",st >= ot?"fixed":"");
  }
}

export function useDocTypeName(docType, defaultName) {
  const nameMap = {
    api: 'API文档',
    guide: '常用文档',
    faq: '常见问题'
  };

  return [nameMap[docType] || defaultName];
}

export function useCategoryId(docType) {
  const categoryMap = {
    api: 1,
    guide: 2,
    faq: 3
  };

  return [categoryMap[docType]];
}

export function useCategoriesApi(docType) {
  const apiMap = {
    api: getApiCategories,
    guide: getApiArticlesNew,
    faq:getApiArticlesNew
  };


  return [apiMap[docType]];
}

export function useArticlesApi(docType) {
  const apiMap = {
    api: getApiArticles,
    guide: getGuideArticles,
    faq: getFAQArticles
  };


  return [apiMap[docType]];
}

export function useDetailApi(docType) {
  const apiMap = {
    api: getApiArticleDetail,
    guide: getGuideArticleDetail,
    faq: getQuestionContentList
  };


  return [apiMap[docType]];
}

export function useReadAddApi() {
  return readContentAdd;
}